import createOperationTypeSplitLink from "../../../internal/revamp/links/createOperationTypeSplitLink";
export default createOperationTypeSplitLink;

//# sourceMappingURL=createOperationTypeSplitLink.js.map